import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { ReportAdapterService } from '../../services/report-adapter.service';
import { ReportAnalysisAPIService } from '../../services/report-analysis-api.service';
import { ReportAnalysisService } from '../../services/report-analysis.service';
import * as ReportActions from './report-analysis.actions';

@Injectable()
export class ReportAnalysisEffect {
    private _actions$ = inject(Actions);
    private _store = inject(Store);
    private reportAPI = inject(ReportAnalysisAPIService);
    private reportAnalysis = inject(ReportAnalysisService);
    private adapter = inject(ReportAdapterService);

    // -----------------------------------------------------------
    // @ Effects
    // -----------------------------------------------------------
    // -----------------------------------------------------------
    // @ Analysis Report Effects
    // -----------------------------------------------------------

    generateInventorySalesAnalysisReport$ = createEffect(() =>
        this._actions$.pipe(
            ofType(ReportActions.generateInventorySalesAnalysisReport),
            switchMap(() =>
                this.reportAPI.getInventorySalesAnalysis().pipe(
                    // Debug
                    // tap((res) => {
                    //     console.log('getInventorySalesAnalysisReport:', res);
                    // }),
                    map((res) =>
                        this.adapter.adaptInventorySalesAnalysisReport(res.data)
                    ),
                    tap((report) =>
                        this.reportAnalysis.getInventorySalesAnalysisFilters(
                            report
                        )
                    ),
                    map((report) =>
                        ReportActions.generateInventorySalesAnalysisReportSuccess(
                            {
                                report,
                            }
                        )
                    ),
                    catchError((error) =>
                        of(
                            ReportActions.generateInventorySalesAnalysisReportFailure(
                                {
                                    error:
                                        error.error?.message || 'Unknown Error',
                                }
                            )
                        )
                    )
                )
            )
        )
    );
}
